import { tWithKeyAttr as t } from "../../i18nHelper";
import { useEffect, useRef, useState } from "react";
import styles from "./venchySpeaking.module.css";
import VenchiTalk from "../../images/speaking.gif";
import Venchi from "../../images/hearing.gif";
import Modal from "../modal/Modal";
import ChatConfirmationPopup from "../chatConfirmationPopup/chatConfirmationPopup";

function VenchySpeaking({ audioUrl }: { audioUrl?: string }) {
  const refAudio = useRef<HTMLAudioElement>(null);
  const [showModal, setShowModal] = useState(false);
  const [isVenchyTalking, setIsVenchyTalking] = useState<boolean>(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  useEffect(() => {
    // debugger
    if (audioUrl && refAudio.current) {
      refAudio.current.load();
      refAudio.current.play().catch((e) => {
        console.error("Failed to play:", e);
      });
    }
  }, [audioUrl]);

  useEffect(() => {
    const audio = refAudio.current;
    if (!audio) return;

    const handlePlay = () => setIsVenchyTalking(true);
    const handleEnded = () => setIsVenchyTalking(false);
    const handlePause = () => setIsVenchyTalking(false);

    audio.addEventListener("play", handlePlay);
    audio.addEventListener("ended", handleEnded);
    audio.addEventListener("pause", handlePause);

    return () => {
      audio.removeEventListener("play", handlePlay);
      audio.removeEventListener("ended", handleEnded);
      audio.removeEventListener("pause", handlePause);
    };
  }, []);

  return (
    <>
      {showModal ? (
        <Modal onClose={() => setShowModal(false)}>
          <ChatConfirmationPopup
            setShowModal={setShowModal}
            setIsVenchyTalking={setIsVenchyTalking}
            refAudio={refAudio}
          />
        </Modal>
      ) : (
        <div className={styles.venchyFixedSide}>
          <img
            src={isVenchyTalking && audioUrl ? VenchiTalk : Venchi}
            alt={isVenchyTalking && audioUrl ? t('VENCHI_MIDBAR') : t('VENCHI_MAKSHIV')}
            className={styles.image}
          />
        </div>
      )}
      <audio
        ref={refAudio}
        autoPlay={!!(audioUrl && isVenchyTalking)}
        src={audioUrl || ""}
      />
    </>
  );
}

export default VenchySpeaking;
